import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { isA, isReporter } from "../../store/utility";
import { updtRequest, fetchRequest } from "../../store/actions/index";
import { ButtonGroup, ButtonToolbar, Breadcrumb, Button, Row, Col } from "react-bootstrap";

import axios from "../../axios-atis";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { Timeline, TimelineEvent } from "react-event-timeline";
import CellStatus from "../../components/UI/Widget/CellStatus"; // ATIS-HABILLAGE-A 01/11/2026
import EchangesClient from "./EchangesClient"; // 04/11/2026 (registre n° 39)

class Request extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      request: null,
      error: null,
      loading: true,
      userId: null,
      isAuthenticated: null,
      company: null,
      requestId: null,
      showEditRequest: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (
      this.props.request !== nextProps.request ||
      this.state.showEditRequest !== nextState.showEditRequest
    ) {
      return true;
    }

    return false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.request !== nextProps.request) {
      this.setState({
        request: nextProps.request,
      });
    }
  }

  componentWillMount() {
    this.setState({ requestId: this.props.match.params.number });
  }

  componentDidMount() {
    this.props.dispatch(fetchRequest(this.state.requestId));
  }

  handlerCancel = (event) => {
    event.preventDefault();
    const { request } = this.state;
    var req = {
      id: request.id,
      status:  2,
    };
    const data = new FormData();
    const json = JSON.stringify(req);
    const blob = new Blob([json], { type: "application/json" });
    data.append("request", blob);

    this.props.dispatch(updtRequest(req.id, data));
  };

  handlerReactivate = (event) => {
    event.preventDefault();
    const { request } = this.state;
    if (!window.confirm("Réactiver la demande n°" + request.numRequest + " ?\nElle repassera en « Envoyée » (à planifier). Aucun mail n'est envoyé au client.")) {
      return;
    }
    axios
      .post("/requests/" + request.id + "/reactivate")
      .then((response) => {
        if (response && response.data && response.data.status === 202) {
          this.props.dispatch(fetchRequest(request.id));
        } else {
          window.alert("Réactivation impossible : " + (response && response.data ? response.data.message : ""));
        }
      })
      .catch(() => window.alert("Réactivation impossible (erreur serveur)."));
  };

  handlerGoBackToPlaned = (event) => {
    event.preventDefault();
    const { request } = this.state;
    var req = {
      id: request.id,
      status: 3,
      executedAt: null
    };
    const data = new FormData();
    const json = JSON.stringify(req);
    const blob = new Blob([json], { type: "application/json" });
    data.append("request", blob);

    this.props.dispatch(updtRequest(req.id, data));
  };
  

  downloadRequestFile = (e, fileId, fileName) => {
    if (null !== e) e.preventDefault();
    axios({
      url: "/requests/" + this.state.requestId + "/download/" + fileId,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      //FileDownload(response.data, row.original.fileName);
    });
  };

  buildBtos(file, index) {
    return (<ButtonGroup key={'bg_' + index}>
      <Button
        bsClass={"btn btn-labeled " + (file.fileType === 'REQUEST' ? 'btn-warning' : 'btn-primary')}
        onClick={(event) =>
          this.downloadRequestFile(event, file.id, file.fileName)
        }
      >
        <span className="btn-label">
          <i className="fa fa-download" />
        </span>{" "}
        {file.fileName}
      </Button>
    </ButtonGroup>);
  }

  render() {
    if (!this.state.request || this.state.request == null) {
      return null;
    }

    const request = this.state.request;
    const responseDate = request.predictedAt;
    const interventionDate = request.executedAt;
    const sortFiles = request.interventionFiles.sort((a, b) => b.id - a.id);
    var events = [];
    
    events.push({
      title: request.name,
      requestType: "DEMANDE",
      subtitle: request.createdAt,
      resume: request.request,
      section: request.section,
      demandeurEmail: request.demandeurEmail,
    });

    if (null !== responseDate) {
      events.push({
        title: "Réponse",
        requestType: "PLANIFICATION",
        subtitle: responseDate,
        resume: request.response,
        messages: request.requestMessages,
      });
    }
    if (null !== interventionDate && request.intervention !== null) {
      const hasPdf = request.interventionFiles.length > 0;
      events.push({
        title: "Intervention",
        requestType: "INTERVENTION",
        subtitle: interventionDate,
        resume: request.intervention.resume,
        hasPdf: hasPdf,
        fileId: hasPdf ? sortFiles[0].id : undefined,
        fileName: hasPdf ? sortFiles[0].fileName : undefined,
      });
    }

    if (request.status === 2) {
      events.push({
        title: "Annulation",
        requestType: "ANNULATION",
        subtitle: request.createdAt,
        resume: "",
      });
    } else if (request.status === 4) {
      events.push({
        title: "Erreur",
        requestType: "ERREUR",
        subtitle: request.createdAt,
        resume: "",
      });
    }

    var btoEventTitle = "";
    if (
      (isA() || isReporter()) &&
      (null == interventionDate || null == responseDate)
    ) {
      if (responseDate == null) {
        btoEventTitle = "Ajouter une réponse";
      } else if (interventionDate === null) {
        btoEventTitle = "Ajouter une intervention";
      }
    }

    const tlEvents = events.map(function (element, index) {
      if (element.requestType === "DEMANDE") {
        return (
          <TimelineEvent
            key={index}
            title={"Demande d'intervention : " + element.title}
            createdAt={"Le " + element.subtitle}
            icon={<i className="fa fa-life-ring" />}
            iconColor="#ff902b"
            container="card"
            style={{
              boxShadow: "0 0 6px 1px #BD3B36",
              border: "1px solid #777",
              borderRadius: 3,
            }}
            cardHeaderStyle={{
              backgroundColor: "#ff902b",
              color: "#FFFFFF",
              fontWeight: "bold",
            }}
            buttons={
              responseDate !== null ? (
                <i className="fa fa-mail-reply" />
              ) : (
                <i className="fa fa-paper-plane" />
              )
            }
          >
            {element.section != null && element.section.length > 0 ? (
              <div>
                <b>Site : </b>
                {element.section}
              </div>
            ) : null}
            {element.demandeurEmail ? (
              <div>
                <b>Envoyé à : </b>
                <a href={"mailto:" + element.demandeurEmail}>{element.demandeurEmail}</a>
              </div>
            ) : null}
            <p>
              <b>Détails : </b>
              <br />
              {element.resume}
            </p>
          </TimelineEvent>
        );
      } else if (element.requestType === "PLANIFICATION") {
        return (
          <TimelineEvent
            key={index}
            title={"Planification de votre demande"}
            createdAt={"Le " + element.subtitle}
            icon={<i className="fa fa-envelope" />}
            iconColor="#5d9cec"
            container="card"
            style={{
              boxShadow: "0 0 6px 1px #BD3B36",
              border: "1px solid #777",
              borderRadius: 3,
            }}
            cardHeaderStyle={{
              backgroundColor: "#5d9cec",
              color: "#FFFFFF",
              fontWeight: "bold",
            }}
            buttons={<i className="fa fa-calendar-check-o" />}
          >
            {element.resume !== null && element.resume.length > 0 ? (
              <p>
                <b>Détails : </b>
                <br />
                {element.resume}
              </p>
            ) : null}
          </TimelineEvent>
        );
      } else if (element.requestType === "INTERVENTION") {
        return (
          <TimelineEvent
            key={index}
            title={"Intervention réalisée"}
            createdAt={"Le " + element.subtitle}
            subtitleStyle={{ fontWeight: "bold" }}
            icon={<i className="fa fa-wrench" />}
            iconColor="#27c24c"
            container="card"
            style={{
              boxShadow: "0 0 6px 1px #BD3B36",
              border: "1px solid #777",
              borderRadius: 3,
            }}
            cardHeaderStyle={{
              backgroundColor: "#27c24c",
              color: "#FFFFFF",
              fontWeight: "bold",
            }}
            buttons={element.hasPdf ? <i className="fa fa-paperclip" /> : null}
          >
            {element.resume !== null && element.resume.length > 0 ? (
              <p>
                <b>Détails : </b>
                <br />
                {element.resume}
              </p>
            ) : null}
          </TimelineEvent>
        );
      } else if (element.requestType === "ANNULATION") {
        return (
          <TimelineEvent
            key={index}
            title={"Demande annulée"}
            subtitleStyle={{ fontWeight: "bold" }}
            icon={<i className="fa fa-ban" />}
            iconColor="#f05050"
            container="card"
            style={{
              boxShadow: "0 0 6px 1px #BD3B36",
              border: "1px solid #777",
              borderRadius: 3,
            }}
            cardHeaderStyle={{
              backgroundColor: "#f05050",
              color: "#FFFFFF",
              fontWeight: "bold",
            }}
          />
        );
      } else if (element.requestType === "ERREUR") {
        return (
          <TimelineEvent
            key={index}
            title={"Erreur lors de l'envoi"}
            subtitleStyle={{ fontWeight: "bold" }}
            icon={<i className="fa fa-ban" />}
            iconColor="#f05050"
            container="card"
            style={{
              boxShadow: "0 0 6px 1px #BD3B36",
              border: "1px solid #777",
              borderRadius: 3,
            }}
            cardHeaderStyle={{
              backgroundColor: "#f05050",
              color: "#FFFFFF",
              fontWeight: "bold",
            }}
          />
        );
      }

      return null;
    });
    
    const requestFiles = request.myRequestFiles.map((file, index) => this.buildBtos(file, index));
    //const planedFiles = request.myRequestFiles.filter(file => file.fileType === "PLANNED").map((file) => this.buildBtos(file));
    const planedFiles = request.interventionFiles.filter(file => file.fileType === "PLANNED").map((file) => this.buildBtos(file));
    //console.log(request);
    return (
      <div className="content-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item href="/#/requests">Interventions</Breadcrumb.Item>
          <Breadcrumb.Item active>
            Intervention n°{request.numRequest}
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* ATIS-HABILLAGE-A 01/11/2026 : en-tête de la fiche (affichage seul) */}
        <div className="atis-fiche-tete">
          <h1>N° {this.state.requestId}</h1>
          {request.status !== null && request.status !== undefined ? <CellStatus requestStatus={request.status} /> : null}
          {request.predictedAt ? <span className="atis-fiche-plan">Planifiée le {request.predictedAt}</span> : null}
          {request.name ? <p className="atis-fiche-titre">{request.name}</p> : null}
        </div>
        {btoEventTitle.length > 0 &&
        (isA() || isReporter()) &&
        request.status !== 2 ? (
          <Row className="form-group content-heading">
            <Col md={12}>
                {request.status === 0 || request.status === 3 ? (
                <Button
                  bsClass="btn btn-labeled btn-danger mr pull-left"
                  style={{ align: "right" }}
                  onClick={(event) => this.handlerCancel(event)}
                >
                  <span className="btn-label">
                    <i className="fa fa-remove" />
                  </span>{" "}
                  Annuler la demande
                </Button>
                ) : null}

              <Link to={`/requests/${this.state.requestId}/edit`}>
                <Button
                  bsClass="btn btn-labeled btn-primary mr pull-right"
                  style={{ align: "right" }}
                >
                  <span className="btn-label">
                    <i className="fa fa-edit" />
                  </span>{" "}
                  &Eacute;diter la demande
                </Button>
              </Link>
            </Col>
          </Row>
        ) : null}

        
        {request.status === 1 ?
          (
          <Row className="form-group content-heading">
            <Col md={12}>
              {(isA() || isReporter()) ? (
                <Button
                  bsClass="btn btn-labeled btn-primary mr pull-left"
                  style={{ align: "right" }}
                  onClick={(event) => this.handlerGoBackToPlaned(event)}
                >
                  <span className="btn-label">
                    <i className="fa fa-envelope" />
                  </span>{" "}
              Revenir à la planification
                </Button>) : null}
                
                {sortFiles.length>0 ? (
            <Button
              bsClass="btn btn-labeled btn-success mr pull-right"
              style={{ align: "right" }}
              onClick={(event) =>
                this.downloadRequestFile(
                  event,
                  sortFiles[0].id,
                  sortFiles[0].fileName
                )
              }
            >
              <span className="btn-label">
                <i className="fa fa-download" />
              </span>{" "}
              Télécharger le bon d'intervention
              </Button>) : null}
            </Col>
          </Row>
          ) : null}
        {request.status === 2 && (isA() || isReporter()) ? (
          <Row className="form-group content-heading">
            <Col md={12}>
              <Button
                bsClass="btn btn-labeled btn-success mr pull-left"
                onClick={(event) => this.handlerReactivate(event)}
              >
                <span className="btn-label">
                  <i className="fa fa-undo" />
                </span>{" "}
                Réactiver la demande
              </Button>
            </Col>
          </Row>
        ) : null}
        <Timeline>{tlEvents}</Timeline>
        {isA() ? (
          <EchangesClient
            request={request}
            onChange={() => this.props.dispatch(fetchRequest(request.id))}
          />
        ) : null}
        {request.status === 3 ?
          (
          <Row className="form-group content-heading">
            <Col md={12}>
              {sortFiles.length>0 ? (
              <Button
                bsClass="btn btn-labeled btn-success mr pull-right"
                style={{ align: "right" }}
                onClick={(event) =>
                  this.downloadRequestFile(
                    event,
                    sortFiles[0].id,
                    sortFiles[0].fileName
                  )
                }
              >
              <span className="btn-label">
                <i className="fa fa-download" />
              </span>{" "}
              Télécharger le bon d'intervention
              </Button>) : null}
            </Col>
          </Row>
          ) : null}
        {request.status === 5 ?
          (
          <Row className="form-group content-heading">
            <Col md={12}>
              {sortFiles.length>0 ? (
              <Button
                bsClass="btn btn-labeled btn-success mr pull-right"
                style={{ align: "right" }}
                onClick={(event) =>
                  this.downloadRequestFile(
                    event,
                    sortFiles[0].id,
                    sortFiles[0].fileName
                  )
                }
              >
              <span className="btn-label">
                <i className="fa fa-download" />
              </span>{" "}
              Télécharger le bon d'intervention
              </Button>) : null}
            </Col>
          </Row>
          ) : null}
        {request.myRequestFiles.length > 0 ? (
          <ButtonToolbar>{requestFiles}</ButtonToolbar>
        ) : null}
        
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    request: state.request.request,
    error: state.request.error,
    loading: state.request.loading,
    userId: state.auth.userId,
    isAuthenticated: state.auth.token !== null,
    company: state.auth.company,
  };
};

export default connect(mapStateToProps)(withErrorHandler(Request, axios));



// WEBPACK FOOTER //
// ./src/containers/Request/Request.js